import React from "react";
import { Navigate, Route } from "react-router-dom";

import ItemDamaged from "../Views/Master/ItemDamaged";
import Category from "../Views/Master/Category";
import SubCategory from "../Views/Master/SubCategory";

import Sdrf1 from "../Views/SDRFManagement/SDRF/Sdrf1";
import Sdrf2 from "../Views/SDRFManagement/SDRF/Sdrf2";
import Sdrf3 from "../Views/SDRFManagement/SDRF/Sdrf3";

import ManageApplications from "../Views/SDRFManagement/ManageSDRF";
import VerifyApplications from "../Views/SDRFManagement/VerifySDRF";
import RejectedApplications from "../Views/SDRFManagement/RejectedSDRF";
import ReliefApproveApplications from "../Views/SDRFManagement/ReliefApproveSDRF";
import HodApproveApplications from "../Views/SDRFManagement/HodApproveSDRF";
import BulkApprovalApplications from "../Views/SDRFManagement/BulkApproval";
import FinalApprovedApplicationsList from "../Views/SDRFManagement/FinalApprovedSDRFList";
import Application from "../Views/SDRFManagement/Application";
import PostApprovalApplications from "../Views/SDRFManagement/PostApproval";
import FailedPaymentApplications from "../Views/SDRFManagement/FailedPaymentApplications";

import ManageRole from "../Views/User/ManageRole";
import ManageUser from "../Views/User/ManageUser";
import NatureOfDisaster from "../Views/Master/NatureOfDisaster";
import SdrfSubmitted from "../Views/SDRFManagement/SDRF/SdrfSubmitted";
import SdrfDocuments from "../Views/SDRFManagement/SDRF/SdrfDocuments";
import Home from "../Views/Dashboard";
import Dashboard from "../Views/Dashboard/Dashboard";
import GenerateReport from "../Views/SDRFReport/GenerateReport";
import CustomReport from "../Views/SDRFReport/CustomReport";
import CalamityReport from "../Views/SDRFReport/CalamityReport";
import PropertyReport from "../Views/SDRFReport/PropertyReport";
import HistoricalReport from "../Views/SDRFReport/HistoricalReport";
import GraphicalReport from "../Views/SDRFReport/GraphicalReport";
import PaymentHistory from "../Views/PaymentHistory";

const useRoute = (permission, roleId) => {
  const accessRoutes = [];
  const accessRouteHome = [];

  if (permission) {
    // Role 3 gets view-only access to Failed Payment Applications (backend restricts the
    // edit/save/upload endpoints to role 8 only — see routes/api.php).
    const hasFailedPaymentAccess =
      permission.includes("HOD") ||
      permission.includes("Relief Officer") ||
      Number(roleId) === 3;

    // eslint-disable-next-line
    let filterAccessRoutes = permission.map((a, i) => {
      if (a !== "Home") {
        if (a === "Dashboard") {
          return <Route path="dashboard" element={<Dashboard />} />;
        } else if (a === "Add SDRF" || a === "Edit SDRF") {
          return (
            <>
              <Route
                path="add-sdrf-notice"
                element={<Navigate to="/sdrf-1" replace />}
              />
              <Route path="sdrf-1" element={<Sdrf1 />} />
              <Route path="sdrf-2" element={<Sdrf2 />} />
              <Route path="sdrf-3" element={<Sdrf3 />} />
              <Route path="sdrf-submitted" element={<SdrfSubmitted />} />
              <Route path="sdrf-documents" element={<SdrfDocuments />} />
              <Route path="application/:id" element={<Application />} />
            </>
          );
        } else if (a === "SDRF Report") {
          return (
            <>
              <Route path="/generate-report" element={<GenerateReport />} />
              <Route path="/custom-report" element={<CustomReport />} />
              <Route path="/calamity-report" element={<CalamityReport />} />
              <Route path="/property-report" element={<PropertyReport />} />
              <Route
                path="/historical-report"
                element={<HistoricalReport />}
              />
               <Route
                path="/graphical-report"
                element={<GraphicalReport />}
              />
            </>
          );
        } else if (a === "Manage SDRF") {
          return (
            <>
              <Route
                path="/manage-applications"
                element={<ManageApplications />}
              />
              <Route path="application/:id" element={<Application />} />
            </>
          );
        } else if (a === "Rejected SDRF") {
          return (
            <>
              <Route
                path="/rejected-applications"
                element={<RejectedApplications />}
              />
              <Route path="application/:id" element={<Application />} />
            </>
          );
        } else if (a === "Nodal Officer") {
          return (
            <>
              <Route
                path="/verify-applications"
                element={<VerifyApplications />}
              />
              <Route path="application/:id" element={<Application />} />
            </>
          );
        } else if (a === "Relief Officer") {
          return (
            <>
              <Route
                path="/relief-approve-applications"
                element={<ReliefApproveApplications />}
              />
              <Route path="application/:id" element={<Application />} />
            </>
          );
        } else if (a === "HOD") {
          return (
            <>
              <Route
                path="/hod-approve-applications"
                element={<HodApproveApplications />}
              />
              <Route
                path="/bulk-approval"
                element={<BulkApprovalApplications />}
              />
              <Route path="/failed-sdrf-1" element={<Sdrf1 />} />
              <Route path="/failed-sdrf-2" element={<Sdrf2 />} />
              <Route path="/failed-sdrf-3" element={<Sdrf3 />} />
              <Route path="/failed-sdrf-submitted" element={<SdrfSubmitted />} />
              <Route path="application/:id" element={<Application />} />
              <Route path="/final-approved-applications" element={<FinalApprovedApplicationsList />} />
            </>
          );
        } else if (a === "View Post Approval Applications") {
          return (
            <>
              <Route
                path="/post-approval-applications"
                element={<PostApprovalApplications />}
              />
              <Route path="application/:id" element={<Application />} />
            </>
          );
        } else if (a === "Payment History") {
          return (
            <>
              <Route
                path="/payment-history"
                element={<PaymentHistory />}
              />
            </>
          );
        } else if (a === "Nature Of Disaster") {
          return (
            <Route path="nature-of-disaster" element={<NatureOfDisaster />} />
          );
        } else if (a === "Item Damaged") {
          return <Route path="item-damaged" element={<ItemDamaged />} />;
        } else if (a === "Category") {
          return <Route path="category" element={<Category />} />;
        } else if (a === "Sub Category") {
          return <Route path="sub-category" element={<SubCategory />} />;
        } else if (a === "Manage Role") {
          return <Route path="manage-role" element={<ManageRole />} />;
        } else if (a === "Manage User") {
          return <Route path="manage-user" element={<ManageUser />} />;
        } else {
          return true;
        }
      } else {
        let home = <Route path="home" element={<Home />} key={i} />;
        accessRouteHome.push(home);
      }
    });

    if (hasFailedPaymentAccess) {
      filterAccessRoutes.push(
        <Route
          path="/failed-payment-applications"
          element={<FailedPaymentApplications />}
        />
      );
    }

    accessRoutes.push(filterAccessRoutes);
    return { accessRoutes, accessRouteHome };
  }

  return "";
};

export default useRoute;
